<template>
  <b-form class="coverage-fieldset d-flex align-items-center">
    <span id="coverage-info" class="info-icon mr-0">
      <font-awesome-icon icon="info-circle" />
    </span>
    <b-tooltip target="coverage-info" triggers="hover click">
      <span>
        {{ $t('coverageAreas') }}
      </span>
      <span v-if="isMobile">
        <br>
        <br>
        {{ $t('refineCoverage') }}
      </span>
    </b-tooltip>
    <b-form-group
      v-if="coverageAreaOptions && coverageAreaOptions.length > 0"
      :label-class="'m-0 py-1'"
      :label="$t('Coverage Area:')"
      label-cols="5"
      class="pb-0 mb-0 ml-2"
    >
      <b-select
        v-model="selected"
        size="sm"
        :options="coverageAreaOptions"
        class="mr-xl-1 font-weight-bold custom-select-coverage"
      >
        <template v-slot:first>
          <b-form-select-option :value="null" disabled>
            {{ $t('Select coverage area') }}
          </b-form-select-option>
        </template>
      </b-select>
    </b-form-group>
    <div v-else class="ml-1 mr-2 font-size-14 mb-0">
      {{ $t('Please add a new coverage') }}
    </div>
  </b-form>
</template>

<script>
import userDevice from "@/imports/mixins/userDevice";
import {SELECTED_COVERAGE} from "@/store/coverage/mutation-types";

export default {
  name: "CoverageDropdown",
  mixins: [userDevice],
  props: ['coverageAreaOptions'],
  computed: {
    selected: {
      get: function() {
        return this.$store.state.coverage.SELECTED_COVERAGE;
      },
      set: function (value) {
        this.$store.commit(SELECTED_COVERAGE, value);
      }
    },
  }
}
</script>
<style scoped lang="scss">
</style>
